<template>
  <a-modal
      title="设置标签"
      :width="960"
      :visible="tagVisible"
      :maskClosable="false"
      @cancel="$emit('cancel')"
      :destroyOnClose="true"
      :confirmLoading="loading">
    <template slot="footer">
      <a-space>
        <a-button type="primary" @click="$emit('cancel')">关闭</a-button>
        <a-button type="primary" :loading="loading" @click="onDelete">清空标签</a-button>
        <a-button type="primary" :loading="loading" @click="ok">保存标签</a-button>
      </a-space>
    </template>
    <a-form-model :model="setForm" ref="setForm" :rules="rules" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="20"
             type="flex"
             align="middle">
        <a-form-model-item label="专家姓名">
         <span v-for="name in expertNames" style="padding: 3px">
               <a-tag color="green">{{ name }}</a-tag>
              </span>
        </a-form-model-item>
        <a-form-model-item label="标签名称" prop="tagId">
          <a-radio-group v-model="setForm.tagId">
            <a-radio-button v-for="item in tagList" :value="item.id"><b :style="'color:'+item.tagColor">{{
                item.tagName
              }}</b></a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="应急状态" v-if="setForm.emergencyFlag">
          <dict-radio dict-key="expert_emergency" v-model="setForm.emergencyFlag"></dict-radio>
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { GetAllTagList } from '@/epp/expertmain/experttag/util/TagUtil'
import { GetExpertNameByIds } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import DictRadio from '@/components/dict/DictRadio.vue'
import { DeleteExpertTagConcern, SaveOrUpdateExpertTagConcern } from '@/epp/expertmain/experttag/api/TagApi'

const rules = {
  tagId: [{ required: true, message: '请选择标签', trigger: 'change' }],
}

export default {
  name: 'EditExpertTagModal',
  components: { DictRadio },
  created () {
  },
  props: {
    tagVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      rules: rules,
      loading: false,
      expertNames: [],
      setForm: {
        tagId: undefined,
      },
      tagList: [],
    }
  },
  methods: {
    onStartLoadData (data) {
      this.setForm = { ...data }
      //获取标签列表
      this.getAllTagList()
      //获取专家名称
      this.getExpertName()
    },
    async ok () {
      let that = this
      that.$refs.setForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          that.loading = true
          let data = {
            ...that.setForm
          }
          let res = await SaveOrUpdateExpertTagConcern(data)
          if (res.code !== 200) {
            return false
          }
          that.$message.success('标签修改成功')
          that.$emit('success')
        } catch (e) {
          that.$message.error(e.message)
        } finally {
          that.loading = false
        }
      })
    },
    async getExpertName () {
      try {
        let res = await GetExpertNameByIds(this.setForm.expertIdList)
        if (res.code !== 200) {
          return false
        }
        this.expertNames = res.result
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async getAllTagList () {
      try {
        this.tagList = await GetAllTagList()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async onDelete () {
      try {
        this.loading = true
        let res = await DeleteExpertTagConcern(this.setForm.expertIdList)
        if (res.code !== 200) {
          return false
        }
        this.$message.success('标签清空成功')
        this.$emit('success')
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
